<div *ngIf="check_refund.is_approved_refund_completed!=3">
    <div class="card">
        <!-- <div class="header">Payment Details</div> -->
        <div class="custom-pad mt-3">
            <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12">
                <label class="weight" for="">Previous Refund Amount</label>
                <input type="number" class="form-control" step="any" placeholder="Previous Refund Amount" disabled [ngModel]="currentData.previous_refund?currentData.previous_refund:currentData.previous_refund_amount" (ngModelChange)="currentData.previous_refund ? currentData.previous_refund : currentData.previous_refund_amount = $event">
            </div>
            <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12">
                <label class="weight" for="">Refundable Amount</label>
                <input type="number" class="form-control" step="any" placeholder="Refundable Amount" disabled [ngModel]="currentData.refund_amount?currentData.refund_amount:currentData.patient_refund_amount" (ngModelChange)="currentData.refund_amount ? currentData.refund_amount : currentData.patient_refund_amount = $event">
            </div>
            <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12" *ngIf="comp == 'opRefund' && cancel_check_box_visible ">
                <label class="check-wrapper weight">
                    <b>Cancel Bill Only </b>
                    <input type="checkbox" (change)="cancelBillWS($event)" class="checkbox"><span  class="check-mark"></span>
                </label>
            </div>
            <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12" *ngIf="isOnline && is_online_checkbox_disabled==false">
                <label class="check-wrapper">
                    <p class="truncate-text">Online Refund Available </p>
                    <input type="checkbox" [attr.disabled]="is_online_checkbox_disabled ? true: null" (change)="checkIsOnline()" [(ngModel)]="currentData.is_online_refund" class="checkbox"><span  class="check-mark"></span>
                </label>
            </div>
            <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12" *ngIf="isOnline && is_online_checkbox_disabled==true">
                <label class="check-wrapper check-disabled">
                    <p class="truncate-text">Online Refund Available </p>
                    <input type="checkbox" [attr.disabled]="is_online_checkbox_disabled ? true: null" (change)="checkIsOnline()" [(ngModel)]="currentData.is_online_refund" class="checkbox"><span  class="check-mark"></span>
                </label>
            </div>
        </div>
        <!-- [dependentField] deliberately NOT bound: routing currentData.setAmount through it made
             every payment add tear this grid down and rebuild it (#171375). The `amount` pre-fill
             is pushed in directly instead - see syncPaymentAmount() / onPaymentFormReady(). -->
        <dhs-composite-array *ngIf="!currentData.is_online_refund && show_pay_detail && !is_transfer" [current_action]="'MODIFY'" [decorator]="self" [resource]="paymentResource" [populateField]="'amount'" [config]="{'delta_update': false}" (valueAdded)="OnPaymentAdd($event);"
            (getData)="onPaymentFormReady($event)"
            (onRemoveItem)="onPaymentRemove($event)" #compositeArrayComponent>
        </dhs-composite-array>
        <div class="row" *ngIf="check_refund.is_approved_refund_completed!=2">
            <div class="col">
                <h5 class="card-title p-ex1">Transfer to UHID</h5>
            </div>
        </div>
        <div class="row" *ngIf="check_refund.is_approved_refund_completed!=2">
                <div class="_wf-bs-blockone mb-2">
                    <div class="_wf-bs-checkbox">
                        <br>
                        <div class="text-block-201 p-ex1">
                            <input type="checkbox" class="_wf-bs-checkbox" [attr.disabled]="(currentData.refund_amount && currentData.refund_amount > 0) || (currentData.patient_refund_amount && currentData.patient_refund_amount > 0) ? null : true" name="transfer_to_uhid" (change)="transferToUHID($event)" id="transferToUHID">
                        </div>
                        <label class="text-block-202" for="transferToUHID">Transfer</label>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12" *ngIf="is_transfer">
                    <label class="text-block-203">Amount to be transfer in UHID</label>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12" *ngIf="is_transfer">
                    <label class="text-block-203">
                        <h5>{{(currentData.refund_amount?currentData.refund_amount:currentData.patient_refund_amount)}}</h5>
                    </label>
                </div>
    </div>
    <div class="row" *ngIf="!currentData.is_online_refund && show_pay_detail && !is_transfer && patientBankDetailsVisible == 'yes'">
            <div class="col">
                <h5 class="card-title p-ex1">Patient Bank Details</h5>
            </div>
        </div>
    <div class="custom-pad ml-3 mb-3" *ngIf= "patientBankDetailsVisible == 'yes'">
        <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12"  *ngIf="!is_transfer">
            <label  for="" class="weight">Account No</label>
            <input type="number" (keypress)="isNumberKey($event,result)" class="form-control" id="account_no" [(ngModel)]="currentData.account_no" placeholder="Enter Account No">
        </div>
        <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12"  *ngIf="!is_transfer">
            <label  for="" class="weight">Branch Name</label>
            <input type="text" class="form-control" id="branch_name" [(ngModel)]="currentData.branch_name" placeholder="Enter Branch Name">
        </div>
        <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12"  *ngIf="!is_transfer">
            <label  for="" class="weight">IFSC Code</label>
            <input type="text" class="form-control" id="ifsc_code" [(ngModel)]="currentData.ifsc_code" placeholder="Enter IFSC Code">
        </div>
        <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12"  *ngIf="!is_transfer">
            <label  for="" class="weight">Beneficiary Name</label>
            <input type="text" class="form-control" id="beneficiary_name" [(ngModel)]="currentData.beneficiary_name" placeholder="Enter Beneficiary Name">
        </div>
        
    </div>
    <div class="row" *ngIf="!is_transfer">
            <div class="col">
                <h5 class="card-title p-ex1">Refund Details</h5>
            </div>
        </div>
        <div class="custom-pad ml-3 mt-2">
            <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12" *ngIf="check_refund.is_approved_refund_completed==2 && !is_transfer">
                <label for="" class="weight required">Refund By</label>
                <input class="form-control" [attr.disabled]="true"
                [(ngModel)]="currentData.authorised_by">
            </div>
            <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12" *ngIf="refundByData && check_refund.is_approved_refund_completed !=2 && !is_transfer">
                <label for="" class="weight required">Refund By</label>
                <select class="form-control" [(ngModel)]="currentData.authorised_by_id" (change)="getAuthorisedName($event);">
                    <option value="">Select</option>
                    <option *ngFor="let data of refundByData.resource;" [value]="data.userId">{{data.userName | titlecase}}
                    </option>
                </select>
            </div>
            <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12">
                <label [ngClass]="refund_remark_mandatory_config_value?'required':''" for="" class="weight">Reason Name</label>
                <!-- <select class="form-control" [(ngModel)]="currentData.refund_reason_name" (change)="getRefundReason($event);">
                    <option value="">Reason Name</option>
                    <option *ngFor="let data of currentData.refundReasonName;" [value]="data.id">{{data.name | titlecase}}
                    </option>
                </select> -->

              
                <kx-multiselect-dropdown
                *ngIf=" reasondatasource.datasource &&  reasondatasource.question != undefined"
                #multiselect [questions]=" reasondatasource.question" [placeholder]="Select"
                [settings]=" reasondatasource.defaultsetting" [(ngModel)]="currentData.refund_reason"
                [data]=" reasondatasource.datasource"
                (onSelect)="reasonSelect($event)"
                (onDeSelect)="reasonDeselect($event)"></kx-multiselect-dropdown>



            <!-- <kx-multiselect-dropdown class="flex-grow-1" *ngIf="reasondatasource != ''" #multiselect
            [disabled]="false" [placeholder]="'Select'" [questions]="question" [settings]="defaultsetting"
            [data]="reasondatasource"
            (onDeSelect)="getRefundReason($event);" (onSelect)="getRefundReason($event)">
  
        </kx-multiselect-dropdown> -->
      
    </div>
    <div class="custom-pad ml-3 mb-3">
        <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12"  *ngIf="!is_transfer">
            <label [ngClass]=" refund_detail_config?'required':''" for="" class="weight">Receiver Name</label>
            <input type="text" class="form-control" id="refund_receiver_name" [(ngModel)]="currentData.refund_receiver_name" placeholder="Enter Receiver Name">
        </div>
        <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12" *ngIf="!is_transfer">
            <label [ngClass]=" refund_detail_config?'required':''" for="" class="weight">Receiver Contact No</label>
            <input type="text" (keypress)="isNumberKey($event,result)" minlength="10" maxlength="12" class="form-control" id="refund_receiver_contact_number" [(ngModel)]="currentData.refund_receiver_contact_number" placeholder="Enter Receiver Contact">
        </div>
        <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12" *ngIf="!is_transfer">
            <label for="" class="weight">Receiver Address</label>
            <input type="text" class="form-control" id="refund_receiver_address" [(ngModel)]="currentData.refund_receiver_address" placeholder="Enter Receiver Address">
        </div>
            <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12" *ngIf="currentData.otp_required">
                <label class="weight required" for="">Enter OTP</label>
                <input type="text" onkeypress='return event.charCode >= 48 && event.charCode <= 57' class="form-control"  maxlength="6"  placeholder="Enter OTP"
                [(ngModel)]="currentData.otp"(change)="checkOTP($event, 'refund')" [attr.disabled]="currentData.otp_verified ? true: null">
            </div>
            <span class="" *ngIf="currentData.otp_required && currentData.timer > 0 && !currentData.otp_verified">Resend OTP in <b>{{currentData.timer}}s</b></span>
            <a href="javascript:void(0)" class="" *ngIf="currentData.otp_required && currentData.timer == 0 && !currentData.otp_verified" (click)="authorizationAction('refund');">Resend OTP</a>
        </div>
        <div class="custom-pad ml-3 mb-3">
            <div class="kx-control col-md-12 col-sm-12 col-lg-12 col-12">
                <label for="" class="weight required">Remarks</label>
                <textarea class="form-control" rows="3" id="remarks" [disabled]="check_refund.is_approved_refund_completed==2" maxlength="250" placeholder="Enter Remarks" [(ngModel)]="currentData.remarks"></textarea>
            </div>
        </div>
        <dhs-composite-array *ngIf="show_refund_document" [current_action]="'ADD'" [decorator]="self"
    [resource]="'insurance_payer_document'" [config]="{'delta_update': false}" (valueAdded)="onDocumentAdd($event);" #compositeArrayComponent>
</dhs-composite-array>
        <!-- </div>
    <div class="card mt-2"> -->
        <div class="text-center m-2">
            <button type="button" class="secondary-btn" (click)="createBill('cancel')">{{'button.cancel' | translate | async }}<i class="fa fa-times ml-2" aria-hidden="true"></i>
            </button>
            <button type="submit" class="ml-2 primary-btn" (click)="createBill('submit')">Submit<i class="fa fa-check  ml-2" aria-hidden="true"></i></button>
            <!-- <input type="button" class="ml-2 btn btn-outline-success btncss" value="View"
                (click)="createBill('view')" />
            <input type="button" class="ml-2 btn btn-outline-success btncss" value="Print"
                (click)="createBill('print')" /> -->
        </div>
    </div>
</div>